import React from 'react';

const EmailSection = ({ currentEmail }: { currentEmail: string }) => (
  <div>
    <label htmlFor="newEmail" className="block text-sm font-medium text-white">
      New Email Address
    </label>
    <input
      type="email"
      id="newEmail"
      name="newEmail"
      placeholder={currentEmail}
      className="mt-1 block w-full rounded-md border-gray-300 bg-gray-800 text-white shadow-sm focus:border-primary focus:ring focus:ring-primary focus:ring-opacity-50"
    />
  </div>
);

export default EmailSection;

